export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "index.worker.e62ecca63f1a2e124230.worker.js");
}
